var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty_list"},[_c('div',{staticClass:"empty_img"}),_c('div',{staticClass:"empty_text"},[_vm._v("게시물이 없습니다.")])])
}]

export { render, staticRenderFns }